module.exports = __webpack_public_path__ + "static/media/transfer-icon.f983db73.svg";